/* eslint-disable no-plusplus */
import React from 'react';

export default function DaysDropDown() {
  const days = [];
  for (let i = 0; i <= 40; i++) {
    days.push(i);
  }
  return (
    days.map((day) => <option value={day}>{day}</option>)
  );
}
